import { StructureDocument } from './StructureDocument.model';

export class BorrowedNote {
    start: string;
    end: string;
    lenderId: string;
    lenderName: string;
    declaration: StructureDocument = new StructureDocument();
    contract: StructureDocument = new StructureDocument();

    loadData(r: any) {
        if(r.start)
            this.start = r.start;

        if(r.end)
            this.end = r.end;

        if (r.lenderId)
            this.lenderId = r.lenderId;

        if (r.lenderName)
            this.lenderName = r.lenderName;

        if(r.declaration)
            this.declaration.loadData(r.declaration);

        if(r.contract)
            this.contract.loadData(r.contract);
    }
}



// WEBPACK FOOTER //
// ./src/app/models/BorrowedNote.model.ts